import "amazon-connect-streams"

enum CCPEvents {
  newContact = 'newContact'
}

class CCPService {
  private events: { [Key: string]: Function[] } = {}


  public async init(containerElement: HTMLElement) {
    window.initCustomCPP(containerElement)
    connect.contact(this.onNewContact.bind(this))
  }


  public async getAgent(): Promise<connect.Agent> {
    return new Promise((resolve, reject) => {
      if (!connect.agent) reject()
      connect.agent((agent => resolve(agent)))
      setTimeout(() => reject(), 5000)
    })
  }


  public subscribeContact(callback: connect.ContactCallback) {
    if (!this.events[CCPEvents.newContact]) this.events[CCPEvents.newContact] = []
    this.events[CCPEvents.newContact].push(callback)
  }


  private onNewContact(contact: connect.Contact): void {
    this.events[CCPEvents.newContact].forEach(callback => {
      callback(contact)
    })
  }
}

export default new CCPService()